import React, { useState, useEffect } from 'react';
import IconButton from '../../components/IconButton';
import Input from '../../components/Input';
import { BackIcon, StartIcon, ForwardIcon, EndIcon } from '../../icons';
import { makeStyles, useTheme } from '@mui/styles';
import { Box } from '../../components';
var usePaginationStyles = makeStyles(function () { return ({
    input: {
        width: '50px',
    },
    inputInner: {
        textAlign: 'center',
        padding: '4px 4px',
        '&::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        '&::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
        },
        appearance: 'textfield',
        MozAppearance: 'textfield',
    },
}); });
var PaginationActions = function (_a) {
    var count = _a.count, page = _a.page, onPageChange = _a.onPageChange, rowsPerPage = _a.rowsPerPage;
    var lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
    var theme = useTheme();
    var classes = usePaginationStyles(theme);
    // Track the page input's value locally to allow user to clear input
    var _b = useState(page + 1), pageInputVal = _b[0], setPageInputVal = _b[1];
    // Reset the page input when any relevant props change
    useEffect(function () {
        setPageInputVal(page + 1);
    }, [page, count, rowsPerPage]);
    var onInputValueChanged = function (ev) {
        // Explicit handling for user clearing input
        if (ev.target.value === '') {
            setPageInputVal(ev.target.value);
            return;
        }
        // Unless input is being cleared, only save valid page numbers
        var pageNum = parseInt(ev.target.value);
        if (pageNum !== null &&
            !isNaN(pageNum) &&
            Number.isInteger(pageNum) &&
            pageNum <= lastPage + 1 &&
            pageNum >= 1) {
            // Note that page starts at 0, pageInputVal starts at 1
            // Manually update pageInputVal, as the useEffect statement may not do so
            setPageInputVal(pageNum);
            onPageChange(null, pageNum - 1);
        }
    };
    return (React.createElement(Box, { display: "flex", flexDirection: "row", alignItems: "center" },
        React.createElement(Box, { mx: 1 },
            React.createElement(IconButton, { size: "small", onClick: function (ev) { return onPageChange(ev, 0); }, disabled: page <= 0 },
                React.createElement(StartIcon, { fontSize: "inherit" }))),
        React.createElement(Box, { mx: 1 },
            React.createElement(IconButton, { size: "small", onClick: function (ev) { return onPageChange(ev, page - 1); }, disabled: page <= 0 },
                React.createElement(BackIcon, { fontSize: "inherit" }))),
        React.createElement(Box, { mx: 1 },
            React.createElement(Input, { type: "number", className: classes.input, inputProps: { className: classes.inputInner }, size: "small", value: pageInputVal, onChange: onInputValueChanged, disabled: lastPage <= 0 }),
            "\u00A0of ",
            lastPage + 1),
        React.createElement(Box, { mx: 1 },
            React.createElement(IconButton, { size: "small", onClick: function (ev) { return onPageChange(ev, page + 1); }, disabled: page >= lastPage },
                React.createElement(ForwardIcon, { fontSize: "inherit" }))),
        React.createElement(Box, { mx: 1 },
            React.createElement(IconButton, { size: "small", onClick: function (ev) { return onPageChange(ev, lastPage); }, disabled: page >= lastPage },
                React.createElement(EndIcon, { fontSize: "inherit" })))));
};
var MuiTablePagination = {
    /* put your new default props here */
    ActionsComponent: PaginationActions,
    rowsPerPageOptions: [],
    labelDisplayedRows: function () { return null; },
};
export default MuiTablePagination;
//# sourceMappingURL=MuiTablePagination.js.map